import { render } from "./GatewayInstallModal.vue?vue&type=template&id=aee8cca8"
import script from "./GatewayInstallModal.vue?vue&type=script&lang=js"
export * from "./GatewayInstallModal.vue?vue&type=script&lang=js"

import "./GatewayInstallModal.vue?vue&type=style&index=0&id=aee8cca8&lang=scss"
script.render = render

export default script